<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="fm01"><a id="pagevii">
<div class="chapterHead">
<h2 class="chapterTitle2"> </h2>
</div>
</a><div class="chapterBody"><a id="pagevii">
<p class="paraNoIndent">I am indebted to the following for support and advice:</p>
<p class="spaceBreak"> </p>
<p class="paraNoIndent">Carolyn Doty, Louise Quayle, and Robert Jones; Jill Bauerle, Darren Brown, Michael Burkin, Eryk Casemiro, Dennis Cooper, Pamela Erwin, Donna Goertz, Marion Heim, Tamyra Heim, Anthony Knight, Eamonn Maguire, Denise Marcil, Kirk McDonald, Perry McMahon, Anne-Marie O’Farrell, Mike Peterson, Jamie Reisch, Scott Savaiano, and Helen Schulman.</p>
</a><a id="pageviii"></a></div><a id="pageviii">
</a></div><a id="pageviii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780061737190_frontmatterpage.vue?33495518